import { Img } from "components/Img";
import styled, { keyframes } from "styled-components";

interface ContainerProps {
  size?: number;
}

interface CircleProps {
  speed?: number;
}

interface ImageProps {
  index: number;
  size: number;
  imageWidth: number;
  imageHeight: number;
}

// Keyframes for infinite rotation
const rotateCircle = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Styled container
const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${(props) => (props.size ? `${props.size}px` : "100%")};
  height: ${(props) => (props.size ? `${props.size}px` : "100%")};
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Styled circle with animation
const Circle = styled.div<CircleProps>`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #D2D2D2;
  position: relative;
  animation: ${rotateCircle} ${(props) => props.speed || 15}s linear infinite;
`;

// Styled images positioned dynamically
const Image = styled.img<ImageProps>`
  position: absolute;
  width: ${(props) => `${props.imageWidth}px`}; 
  height: ${(props) => `${props.imageHeight}px`}; 
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
    rotate(${(props) => props.index * (360 / 3)}deg)
    translate(${(props) => `${props.size * 0.5}px`})
    rotate(${(props) => -props.index * (360 / 3)}deg);
`;

const StackedImages = () => {
  return (
    <div className="relative flex justify-center w-full h-[130px]">
      <div className="absolute top-[-30px]">
        <RotatingCircle
          images={[
            "/images/new-landing-page/graphUp.svg",
            "/images/new-landing-page/hatSwap.svg",
            "/images/new-landing-page/rupeeSymbol.svg",
          ]}
          size={200}
          speed={15}
          imageWidth={60}  // Dynamic image width
          imageHeight={60} // Dynamic image height
        />
      </div>
      <div className="absolute top-[-2px]">
        <RotatingCircle
          images={[
            "/images/new-landing-page/pieChart.svg",
            "/images/new-landing-page/laptop.svg",
            "/images/new-landing-page/idCard.svg",
          ]}
          size={140}
          speed={10}
          imageWidth={55}  // Dynamic image width
          imageHeight={55} // Dynamic image height
        />
      </div>
      <div className="absolute top-[35px]">
        <Img src={"/images/new-landing-page/earthBlue.svg"} />
      </div>
    </div>
  );
};

export default StackedImages;

const RotatingCircle = ({ speed, images, size, imageWidth, imageHeight }) => {
  return (
    <Container size={size}>
      <Circle speed={speed}>
        {images?.map((item, index) => (
          <Image 
            key={index} 
            src={item} 
            alt={`Image ${index + 1}`} 
            index={index} 
            size={size} 
            imageWidth={imageWidth} 
            imageHeight={imageHeight} 
          />
        ))}
      </Circle>
    </Container>
  );
};
